import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import useSWR from 'swr';
import {withSize} from 'react-sizeme';
import PropTypes from 'prop-types';
import axiosInstance from '../../../shared/utils/axios';
import {Page, DescriptiveText} from '../../../shared';
import {_openModal} from '../../../shared/reducers/modals';
import AccountGroup from '../../components/groups/AccountGroup';
import StickyHeaderBar from '../../shared/components/StickyHeaderBar';

const AccountGroups = (props) => {
  const {openModal, size, session} = props;
  const {data: groups, mutate: refreshGroups} = useSWR('/groups');

  const addAccountGroup = () => openModal({
    type: 'ManageGroupModal',
    onSuccess: () => refreshGroups(),
  });

  const removeAccountGroup = (groupId) => openModal({
    type: 'ConfirmModal',
    title: 'Remove Account Group',
    body: <DescriptiveText preset={'standard'}>This will permanently remove the account group and any history associated with it. It will NOT affect the individual accounts in any way. This action can not be undone.</DescriptiveText>,
    button: {
      text: 'Remove',
      action:
          () => axiosInstance.delete(`/groups/${groupId}`)
            .then(() => refreshGroups())
            .catch(err => openModal({type: 'Error', title: 'Delete Account Group', err: err})),
      size: 'sm',
      width: '110px',
    },
  });

  const editAccountGroup = (groupId, groupName) => openModal({
    type: 'ManageGroupModal',
    groupId: groupId,
    groupName: groupName,
    onSuccess: () => refreshGroups(),
  });

  const accountGroups = groups && groups.map((group, index) => <AccountGroup
      key={group.id}
      group={group}
      removeAccountGroup={removeAccountGroup}
      editAccountGroup={editAccountGroup}
      margin={index === groups.length - 1 ? '10px 10px 20px 10px' : '10px'}
      size={size}/>);

  return <Page>
    <StickyHeaderBar title={'ACCOUNT GROUPS'}
                     buttons={{
                       primary: {
                         label: 'Add Group',
                         action: addAccountGroup,
                         isDisabled: !!session.runAsInvestor,
                       }}}
    />
    {accountGroups}
  </Page>;
};

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default compose(withSize(), connect(mapStateToProps, mapDispatchToProps))(AccountGroups);

AccountGroups.propTypes = {
  /**
   * Session
   */
  session: PropTypes.shape({
    runAsInvestor: PropTypes.number.isRequired,
  }),
  /**
   * The open function that dispatches _openModal from Redux
   */
  openModal: PropTypes.func.isRequired,
  /**
   * SizeMe size
   */
  size: PropTypes.shape({
    width: PropTypes.number,
  }),
};
